'use strict';

var KayleeUtil = require('./KayleeUtil');
var log = require('../log/Log').channel('FirebaseExt');

var FirebaseExt = {
    offUpdate: offUpdate,
    onUpdate: onUpdate,
    update: update,
};

var releaseTimeoutId = null;
var releaseTimeMs = 1000;
var updateTimeoutId = null;
var initialUpdateTimeMs = 20;
var updateTimeMs = 250;
var updateListeners = [];

function offUpdate(listener) {
    for (var i = 0; i < updateListeners.length; i++) {
        if (updateListeners[i] === listener) {
            updateListeners.splice(i, 1);
            return;
        }
    }

    log.error('offUpdate: listener not found');
}

function onUpdateTimeout() {
    updateListeners.forEach(function(listener) {
        listener();
    });

    if (releaseTimeoutId !== null) {
        updateTimeoutId = KayleeUtil.setTimeout(onUpdateTimeout, updateTimeMs);
    } else {
        updateTimeoutId = null;
    }
}

function onReleaseTimeout() {
    releaseTimeoutId = null;
}


function onUpdate(listener) {
    updateListeners.push(listener);
}

function update() {
    if (releaseTimeoutId) KayleeUtil.clearTimeout(releaseTimeoutId);
    releaseTimeoutId = KayleeUtil.setTimeout(onReleaseTimeout, releaseTimeMs);
    if (updateTimeoutId === null) {
        updateTimeoutId = KayleeUtil.setTimeout(onUpdateTimeout, initialUpdateTimeMs);
    }
}

module.exports = FirebaseExt;
